var map = {
	"./background-desktop.png": 4691,
	"./background-mocca.png": 2460,
	"./background-pattern.png": 605,
	"./background.png": 1964,
	"./football-mob.png": 3810,
	"./frame.svg": 8513,
	"./sandwich.svg": 1745,
	"./stopwatch.svg": 8635
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;